import React from 'react';
import Tooltip from './';
import styles from './Tooltip.scss';

export default function LabelWithTooltip(props) {
    return (
        <label className={styles.helperText}>
            {props.children}
            <Tooltip content={props.message} direction='top'>
                <i className={styles.icon}/>
            </Tooltip>
        </label>
    );
}
